import { render, staticRenderFns } from "./webhooks.vue?vue&type=template&id=678cec56&"
import script from "./webhooks.vue?vue&type=script&lang=ts&"
export * from "./webhooks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports